import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Each line takes the direction of its first letter (`unicode-bidi:
 * plaintext`), so a message mixing Arabic and English lines lays out both
 * correctly, and an empty field keeps the page's direction. See ui/input.tsx
 * for why this is not `dir="auto"`. An explicit `dir` always wins (RTL-06).
 */
function Textarea({ className, dir, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      dir={dir}
      className={cn(
        "flex field-sizing-content min-h-16 w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:aria-invalid:ring-destructive/40",
        dir === undefined && "[unicode-bidi:plaintext]",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
